import * as React from 'react';

import Button from 'components/ButtonDeprecated';

import './styles/BoxButton.scss';

type Props = {
  children?: React.ReactNode;
};

/**
 * ## Full-width [Button](/internal/components/Button) footer for use in a [Box](/internal/components/Box).
 * ### Primarily used to render calls-to-action on mobile web. Avoid usage otherwise and opt for [BoxFooter](/internal/components/BoxFooter) instead.
 *
 *
 * ```example
 * <Box>
 *   <BoxHeader title="Box" />
 *   <BoxBody>
 *     Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt
 *     ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation
 *     ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in
 *     reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.
 *   </BoxBody>
 *   <BoxButton>BoxButton</BoxButton>
 * </Box>
 * ```
 */

export default function BoxButton(props: Props) {
  const { children, ...rest } = props;

  return (
    <Button {...rest} full className="BoxButton" eventElementName="BoxButton">
      {children}
    </Button>
  );
}
